module.exports = __webpack_public_path__ + "media/icons/dane-white-b865e8b6.svg";